"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyStateButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../ButtonTertiary/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["semanticColor", "condensed"];
var EmptyStateButtonComponent = (0, _styledComponents["default"])(_index.ButtonTertiary).withConfig({
  displayName: "EmptyStateButton__EmptyStateButtonComponent",
  componentId: "sc-1m67ey1-0"
})(["margin-block:7px -17px;max-inline-size:100%;overflow-wrap:break-word;"]);

/**
 * EmptyStateButton is a CTA a user can take.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate-emptystatebutton--docs) |
 * [Encore site](https://encore.spotify.net/web/components/empty-state) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyStateButton) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=9280-1056&t=uvnU5TzlyKmXuODT-1)
 */
var EmptyStateButton = exports.EmptyStateButton = function EmptyStateButton(_ref) {
  var _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'textBrightAccent' : _ref$semanticColor,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? true : _ref$condensed,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(EmptyStateButtonComponent, Object.assign({
    semanticColor: semanticColor,
    condensed: condensed
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.EmptyStateButton
  }));
};